import { render, staticRenderFns } from "./hangingDevice.vue?vue&type=template&id=c0f80b84&scoped=true&"
import script from "./hangingDevice.vue?vue&type=script&lang=js&"
export * from "./hangingDevice.vue?vue&type=script&lang=js&"
import style0 from "./hangingDevice.vue?vue&type=style&index=0&id=c0f80b84&scoped=true&lang=css&"
import style1 from "./particulars.css?vue&type=style&index=1&id=c0f80b84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f80b84",
  null
  
)

export default component.exports